<template>
  <div>
    <img class="background-img col-12 cover h100" src="../assets/space.jpg">
    <!-- <img class="background-img col-12 cover h100 flying-body" src="../assets/cls_sideview.png"> -->

    <div class="flex col-12 justify-between">
      <img class="cbx-logo" src="../assets/CQL_logo_kombi.svg">
    </div>

    <div class="login-window box-shadow-big mx-auto bg-color-darkgray rounded-border">
      <div class="pt4 pr3 pl3 pb3">
        <div class="col-12 flex justify-center flex-column">
          <svg class="mx-auto" width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M18.48 6.4492C18.2132 6.25255 17.8792 6.17 17.5516 6.2197C17.2239 6.2694 16.9294 6.44729 16.733 6.7142L10.809 14.7542L7.042 11.7402C6.50174 11.3263 5.72976 11.4203 5.30453 11.9516C4.87929 12.483 4.95681 13.2568 5.479 13.6932L10.262 17.5192C10.529 17.728 10.8687 17.8208 11.2048 17.7766C11.5409 17.7324 11.8451 17.555 12.049 17.2842L18.749 8.1972C18.9453 7.92978 19.0272 7.59531 18.9768 7.26745C18.9263 6.93959 18.7476 6.64523 18.48 6.4492Z" fill="white"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M0 12C0 5.37256 5.37259 0 12 0C18.6245 0.00732422 23.9928 5.37549 24 12C24 18.6274 18.6274 24 12 24C5.37259 24 0 18.6274 0 12ZM2 12C2 17.5229 6.47714 22 12 22C17.5203 21.9941 21.9939 17.5205 22 12C22 6.47705 17.5229 2 12 2C6.47714 2 2 6.47705 2 12Z" fill="white"/>
          </svg>
          <p class="h2 white bold mx-auto center pb4 pt2">{{$t('logout_p_erfolgreich_ausgeloggt')}}</p>
        </div>
      </div>
      <div class="divider">
      </div>
      <div class="bg-color-darkgray pr4 pl4 pt3 pb3 rounded-border-bottom flex">
        <div class="flex align-middle">
          <p class="p-small regular color-gray">{{$t('logout_p_zurueck_zum_login')}}</p>
          <router-link class="btn btn-small ml3" :to="'/' + this.$i18n.locale" >{{$t('logout_btn_login')}}</router-link>
        </div>
        <div class="flex align-middle ml3">
          <p class="p-small regular color-gray">{{$t('logout_p_mehr_ueber_hohlkoerper')}}</p>
          <a class="btn btn-ghost-narrow ml3 self-center" href="https://www.cobiax.com/">{{$t('logout_a_cobiax_website')}}</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>



export default {
  name: "LogOut",
  data() {
    return {
      debug: false,
    };
  },

  methods: {


  },

};
</script>
<style scoped>
</style>
